var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminNav'),_c('div',{staticClass:"wrapper"},[_c('h1',{staticClass:"mb-5"},[_vm._v("Add a new resource")]),_c('ResourceForm',{on:{"submit":_vm.handleSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }